export enum ChangesStrategy {
  Each,
  First,
  NonFirst,
}
